import React, { FunctionComponent } from 'react';
import { Accordion, AccordionDetails, Typography, Grid, AccordionSummary } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import styles from '../../ime-response-summary/ImeResponseSummary.Styles';
import ReferralStatusEntity from '../../../../../entities/ReferralStatus.Entity';

interface IFcmResponseSummaryProps {
    referralStatus: ReferralStatusEntity;
}

export const FcmResponseSummary: FunctionComponent<IFcmResponseSummaryProps> = (props: IFcmResponseSummaryProps) => {
    const classes = styles();

    return (
        <Accordion defaultExpanded={true} className={classes.paper} square>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon className={classes.paperHeaderIcon} />}
                aria-controls="fcm-response-content"
                id="fcm-response-accordion"
                className={classes.paperHeader}
            >
                <Typography variant="subtitle2" className={classes.paperTitle}>
                    FCM
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={3} className={classes.gridContainer}>
                    <Grid item xs={3}>
                        <Typography variant="body2" className={classes.dataLabel}>
                            Referral Status
                        </Typography>
                        <Typography variant="subtitle2" className={classes.blackFont}>
                            {props.referralStatus?.referralStatusLabel}
                        </Typography>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};
